<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'PROTOCOLS', pageCode: 'ALL', subPageCode: 'ADD' }">
  <app-module-header [label]="btnLabel" (onBtnClick)="onAddTrial()" [showImportExportBtn]="showImportExportBtn"
    [showLastSync]="false"></app-module-header>
</div>
<div>
  <p-tabView [(activeIndex)]="activeIndex" (onChange)="tabViewChange($event)" [scrollable]="true">
    @if(isTabAllAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.DASHBOARD_ACTIVITY_FEED}} inline-block wh-14 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 0, 'inactive-tab-label': activeIndex !== 0}"
          class="tab-label" translate>protocol.lbl_all</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.ALL}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        @if(data){
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="protocol"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteTrialMsg"
          [header]="deleteTrialHeaderMsg"
          (onDelete)="onTrialDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          (onValueChange)="onFilterValueChange($event)"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddVehicle()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          (onUpdate)="onUpdateTrial($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          [visible]="visible"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
        }
      </ng-template>
    </p-tabPanel>
    }
    @if(isTabDraftAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.FILE_FOLDER}} inline-block wh-14 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 1, 'inactive-tab-label': activeIndex !== 1}"
          class="tab-label" translate>protocol.lbl_draft</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.DRAFT}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="protocol"
          [isLoading]="isLoading"
          [totalRecords]="totalRecords"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteTrialMsg"
          [header]="deleteTrialHeaderMsg"
          (onDelete)="onTrialDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddVehicle()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          [rowItems]="rowItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          (onUpdate)="onUpdateTrial($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
      </ng-template>
    </p-tabPanel>
    }

    @if(isTabRunningAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.ORDER_ACTIVE}} inline-block wh-16 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 1, 'inactive-tab-label': activeIndex !== 1}"
          class="tab-label" translate>protocol.lbl_running</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.RUNNING}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="protocol"
          [isLoading]="isLoading"
          [totalRecords]="totalRecords"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteTrialMsg"
          [header]="deleteTrialHeaderMsg"
          (onDelete)="onTrialDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddVehicle()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          [rowItems]="rowItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          (onUpdate)="onUpdateTrial($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
      </ng-template>
    </p-tabPanel>
    }
    @if(isTabCompletedAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="{{miIcons.CIRCLE_CHECKED}} inline-block wh-16 mr-2 relative"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 1, 'inactive-tab-label': activeIndex !== 1}"
          class="tab-label" translate>protocol.lbl_completed</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.COMPLETED}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="protocol"
          [isLoading]="isLoading"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [totalRecords]="totalRecords"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteTrialMsg"
          [header]="deleteTrialHeaderMsg"
          (onDelete)="onTrialDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddVehicle()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          (onUpdate)="onUpdateTrial($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
      </ng-template>
    </p-tabPanel>
    }
    @if(isTabInactiveAllowed){
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-times-circle mr-2"></i>
        <span [ngClass]="{'active-tab-label': activeIndex === 1, 'inactive-tab-label': activeIndex !== 1}"
          class="tab-label" translate>protocol.lbl_inactive</span>&nbsp;<span
          class="iconNumber text-color-secondary">({{entityCount?.counts?.INACTIVE}})</span>
      </ng-template>
      <ng-template pTemplate="body">
        <app-mi-table
          [collectionOfColumns]="allColumns"
          [attributeLabels]="filterAttributeLabels"
          [data]="tableData"
          entityName="protocol"
          [isLoading]="isLoading"
          [totalRecords]="totalRecords"
          (onPageChange)="onPageChange($event)"
          (itemPerPageChange)="itemPerPageChange($event)"
          [itemsPerPage]="itemsPerPage"
          [message]="deleteTrialMsg"
          [header]="deleteTrialHeaderMsg"
          (onDelete)="onTrialDelete($event)"
          (onBulkDataDeleteEvent)="onBulkDataDeleteEvent($event)"
          (onRowSelection)="onRowSelect($event)"
          [filterList]="filterList"
          [filterFields]="filterFieldsArray"
          [label]="btnLabel"
          (onBtnClick)="onAddVehicle()"
          [bulkUpdateLabel]="bulkUpdateLabel"
          [bulkDeleteLabel]="bulkDeleteLabel"
          (onValueChange)="onFilterValueChange($event)"
          [attributeData]="attributeData"
          (onBulkDataUpdateEvent)="onBulkDataUpdateEvent($event)"
          (onSearchValueChange)="onSearchValueChanges($event)"
          [bulkUpdateHeader]="bulkUpdateHeader"
          [reviewHeader]="reviewHeader"
          [btnUpdate]="btnUpdate"
          [rowItems]="rowItems"
          (setCurrentRowData)="setCurrentRowData($event)"
          (onUpdate)="onUpdateTrial($event)"
          [rowItems]="rowItems"
          [bulkSelectionsItems]="bulkSelectionsItems"
          [visible]="visible"
          [visiblePrintLabel]="visiblePrintLabel"
          [showBulkUpdateDialog]="showBulkUpdateDialog"
          (onToggleOverLay)="showBulkUpdateDialog = false; visiblePrintLabel = false"
          (onSortData)="onSortData($event)"
          [isEntity]="isEntity">
        </app-mi-table>
      </ng-template>
    </p-tabPanel>
    }
  </p-tabView>
</div>
<p-toast></p-toast>
<input hidden type="file" id="upload" (change)="onChange($event)"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" #uploader>